/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPCOUNTRY } from './IAPCOUNTRY';
import {
    IAPCOUNTRYFromJSON,
    IAPCOUNTRYFromJSONTyped,
    IAPCOUNTRYToJSON,
} from './IAPCOUNTRY';

/**
 * 
 * @export
 * @interface ContactInfoViewModel
 */
export interface ContactInfoViewModel {
    /**
     * 
     * @type {number}
     * @memberof ContactInfoViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactInfoViewModel
     */
    productId: number;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoViewModel
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoViewModel
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoViewModel
     */
    emailAddress?: string;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof ContactInfoViewModel
     */
    countryCodeId?: IAPCOUNTRY;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoViewModel
     */
    countryDialingCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoViewModel
     */
    phoneNumber?: string;
}

/**
 * Check if a given object implements the ContactInfoViewModel interface.
 */
export function instanceOfContactInfoViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "productId" in value;

    return isInstance;
}

export function ContactInfoViewModelFromJSON(json: any): ContactInfoViewModel {
    return ContactInfoViewModelFromJSONTyped(json, false);
}

export function ContactInfoViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactInfoViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'productId': json['ProductId'],
        'firstName': !exists(json, 'FirstName') ? undefined : json['FirstName'],
        'surname': !exists(json, 'Surname') ? undefined : json['Surname'],
        'emailAddress': !exists(json, 'EmailAddress') ? undefined : json['EmailAddress'],
        'countryCodeId': !exists(json, 'CountryCodeId') ? undefined : IAPCOUNTRYFromJSON(json['CountryCodeId']),
        'countryDialingCode': !exists(json, 'CountryDialingCode') ? undefined : json['CountryDialingCode'],
        'phoneNumber': !exists(json, 'PhoneNumber') ? undefined : json['PhoneNumber'],
    };
}

export function ContactInfoViewModelToJSON(value?: ContactInfoViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'ProductId': value.productId,
        'FirstName': value.firstName,
        'Surname': value.surname,
        'EmailAddress': value.emailAddress,
        'CountryCodeId': IAPCOUNTRYToJSON(value.countryCodeId),
        'CountryDialingCode': value.countryDialingCode,
        'PhoneNumber': value.phoneNumber,
    };
}

